import { normalize, schema } from 'normalizr';

const sonarSchema = new schema.Entity('sonar');
const sonarListSchema = [sonarSchema];

// Normalize and adapt sonar list data for the store
export function adaptSonarListToStore({ data }) {
  const normalizedData = normalize(data.results, sonarListSchema);
  const { entities: { sonar: entries }, result } = normalizedData;

  const results = data.results.map((sonar, index) => ({
    ...sonar,
    skill_area_id: result[index],
  }));

  return {
    entries,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results,
  };
}

// Prepare sonar data for API submission
export function adaptSonarToApi(sonar = {}) {
  const { summary, created, modified, id, sonarId, ...payload } = sonar;
  return payload;
}

function adaptSonarData(data) {
  const totalCounts = {
    novice: { questions: 0, labs: 0, configCount: 0 },
    professional: { questions: 0, labs: 0, configCount: 0 },
    advanced: { questions: 0, labs: 0, configCount: 0 },
  };

  data.SkillArea.Assessments.forEach(({ assessmentInfo: { difficulty }, assessmentConfig }) => {
    // Handle multiple configs by summing up their questions and labs
    const configTotals = assessmentConfig.reduce(
      (acc, config) => {
        acc.questions += config.questions.length;
        acc.labs += config.labs.length;
        return acc;
      },
      { questions: 0, labs: 0 }
    );

    if (totalCounts[difficulty]) {
      totalCounts[difficulty].questions += configTotals.questions;
      totalCounts[difficulty].labs += configTotals.labs;

      // Only increment configCount if there are questions or labs
      if (configTotals.questions > 0 || configTotals.labs > 0) {
        totalCounts[difficulty].configCount += assessmentConfig.length;
      }
    }
  });

  const summary = Object.keys(totalCounts).map(level => ({
    difficulty: level,
    questions: totalCounts[level].questions,
    labs: totalCounts[level].labs,
    configCount: totalCounts[level].configCount
  }));

  return { ...data, summary };
}

// Adapt fetched sonar data for store with additional fields
export function adaptSonarFetchToStore({ data }) {
  const adaptedData = adaptSonarData(data.content);
  return adaptedData;
}

// Adapt sonar data for store with additional metadata
export function adaptSonarToStore({ data }) {
  const adaptedData = adaptSonarData(data);

  return {
    ...adaptedData,
    id: data.SkillArea.id,
    modified: data.SkillArea.modified,
    created: data.SkillArea.created,
  };
}
